/* eslint-disable prettier/prettier */ /**
 * Do not edit directly
 * Generated on Fri, 25 Apr 2025 08:51:03 GMT
 */
const PrimaryMain = "#004851ff";
const PrimaryOnMain = "#f8faf9ff";
const PrimaryAlt = "#badddaff";
const PrimaryOnAlt = "#001f27ff";
const PrimaryAltOverlay = "#f5f8f980";
const PrimaryMainOverlay = "#001f2480";
const SecondaryMain = "#b23d59ff";
const SecondaryOnMain = "#ffffffff";
const SecondaryAlt = "#f2d4d7ff";
const SecondaryOnAlt = "#370c18ff";
const SecondaryMainOverlay = "#581a2980";
const SecondaryAltOverlay = "#ffffff80";
const SurfaceMain = "#ffffffff";
const SurfaceContrastMid = "#ecf0f3ff";
const SurfaceContrastLeast = "#f9fafbff";
const SurfaceContrastLow = "#f3f5f7ff";
const SurfaceContrastHigh = "#e6ebefff";
const SurfaceContrastMost = "#e0e6ebff";
const SurfaceOnSurface = "#1e282fff";
const SurfaceOnSurfaceAlt = "#465d6dff";
const SurfaceOutline = "#c1ced7ff";
const SurfaceOverlay = "#1b1e1d1a";
const DangerMain = "#e62600ff";
const DangerOnMain = "#ffffffff";
const DangerAlt = "#fadbdbff";
const DangerOnAlt = "#650a00ff";
const DangerAltOverlay = "#ffffff80";
const DangerMainOverlay = "#581a2980";
const WarningMain = "#f5cd3dff";
const WarningOnMain = "#332800ff";
const WarningAlt = "#f5eed6ff";
const WarningOnAlt = "#665000ff";
const WarningAltOverlay = "#33280080";
const WarningMainOverlay = "#66500080";
const SuccessMain = "#3a9263ff";
const SuccessOnMain = "#ffffffff";
const SuccessAlt = "#e1eae5ff";
const SuccessOnAlt = "#184e31ff";
const SuccessAltOverlay = "#ffffff80";
const SuccessMainOverlay = "#184e3180";
const DisabledOverlay = "#7079764d";
const DisabledOverlayStrong = "#1b1e1d4d";
const MiscScrim = "#1b1e1d4d";
const MiscLink = "#0066ccff";
const NeutralAlt = "#e0e6ebff";
const NeutralOnAlt = "#32424eff";
const NeutralMain = "#5a778cff";
const NeutralOnMain = "#f9fafbff";
const DisplayGreenMain = "#3a9263ff";
const DisplayGreenOnMain = "#e1eae5ff";
const DisplayGreenMainOverlay = "#ffffffff";
const DisplayGreenAlt = "#c0d8cbff";
const DisplayGreenOnAlt = "#184e31ff";
const DisplayGreenAltOverlay = "#ffffffff";
const DisplayYellowMain = "#f5cd3dff";
const DisplayYellowOnMain = "#332800ff";
const DisplayYellowMainOverlay = "#ffffffff";
const DisplayYellowAlt = "#f0e0a8ff";
const DisplayYellowOnAlt = "#665000ff";
const DisplayYellowAltOverlay = "#ffffffff";
const DisplayRedMain = "#ba1d00ff";
const DisplayRedOnMain = "#fadbdbff";
const DisplayRedMainOverlay = "#ffffffff";
const DisplayRedAlt = "#f8b6b4ff";
const DisplayRedOnAlt = "#650a00ff";
const DisplayRedAltOverlay = "#ffffffff";
const DisplayPumpkinMain = "#9b450bff";
const DisplayPumpkinOnMain = "#fadebfff";
const DisplayPumpkinMainOverlay = "#ffffffff";
const DisplayPumpkinAlt = "#f7bb79ff";
const DisplayPumpkinOnAlt = "#601500ff";
const DisplayPumpkinAltOverlay = "#ffffffff";
const DisplayFlamingoMain = "#a62c77ff";
const DisplayFlamingoOnMain = "#ffd7f2ff";
const DisplayFlamingoMainOverlay = "#ffffffff";
const DisplayFlamingoAlt = "#fab0e0ff";
const DisplayFlamingoOnAlt = "#63013dff";
const DisplayFlamingoAltOverlay = "#ffffffff";
const DisplayVioletMain = "#6f5093ff";
const DisplayVioletOnMain = "#ecdcffff";
const DisplayVioletMainOverlay = "#ffffffff";
const DisplayVioletAlt = "#dbb8ffff";
const DisplayVioletOnAlt = "#332e3bff";
const DisplayVioletAltOverlay = "#ffffffff";
const DisplayNightMain = "#4759a8ff";
const DisplayNightOnMain = "#dae2ffff";
const DisplayNightMainOverlay = "#ffffffff";
const DisplayNightAlt = "#b5c4ffff";
const DisplayNightOnAlt = "#2b2e4aff";
const DisplayNightAltOverlay = "#ffffffff";
const DisplayOceanMain = "#006782ff";
const DisplayOceanOnMain = "#cee7eeff";
const DisplayOceanMainOverlay = "#ffffffff";
const DisplayOceanAlt = "#8cd1e5ff";
const DisplayOceanOnAlt = "#003548ff";
const DisplayOceanAltOverlay = "#ffffffff";
const DisplayMonsoonMain = "#5a778cff";
const DisplayMonsoonOnMain = "#f9fafbff";
const DisplayMonsoonMainOverlay = "#ffffffff";
const DisplayMonsoonAlt = "#c1ced7ff";
const DisplayMonsoonOnAlt = "#32424eff";
const DisplayMonsoonAltOverlay = "#ffffffff";
const InfoMain = "#005cbaff";
const InfoOnMain = "#f8f9feff";
const InfoMainOverlay = "#002f6580";
const InfoAlt = "#dae2fcff";
const InfoOnAlt = "#002f65ff";
const InfoAltOverlay = "#f8f9fe80";

export { DangerAlt, DangerAltOverlay, DangerMain, DangerMainOverlay, DangerOnAlt, DangerOnMain, DisabledOverlay, DisabledOverlayStrong, DisplayFlamingoAlt, DisplayFlamingoAltOverlay, DisplayFlamingoMain, DisplayFlamingoMainOverlay, DisplayFlamingoOnAlt, DisplayFlamingoOnMain, DisplayGreenAlt, DisplayGreenAltOverlay, DisplayGreenMain, DisplayGreenMainOverlay, DisplayGreenOnAlt, DisplayGreenOnMain, DisplayMonsoonAlt, DisplayMonsoonAltOverlay, DisplayMonsoonMain, DisplayMonsoonMainOverlay, DisplayMonsoonOnAlt, DisplayMonsoonOnMain, DisplayNightAlt, DisplayNightAltOverlay, DisplayNightMain, DisplayNightMainOverlay, DisplayNightOnAlt, DisplayNightOnMain, DisplayOceanAlt, DisplayOceanAltOverlay, DisplayOceanMain, DisplayOceanMainOverlay, DisplayOceanOnAlt, DisplayOceanOnMain, DisplayPumpkinAlt, DisplayPumpkinAltOverlay, DisplayPumpkinMain, DisplayPumpkinMainOverlay, DisplayPumpkinOnAlt, DisplayPumpkinOnMain, DisplayRedAlt, DisplayRedAltOverlay, DisplayRedMain, DisplayRedMainOverlay, DisplayRedOnAlt, DisplayRedOnMain, DisplayVioletAlt, DisplayVioletAltOverlay, DisplayVioletMain, DisplayVioletMainOverlay, DisplayVioletOnAlt, DisplayVioletOnMain, DisplayYellowAlt, DisplayYellowAltOverlay, DisplayYellowMain, DisplayYellowMainOverlay, DisplayYellowOnAlt, DisplayYellowOnMain, InfoAlt, InfoAltOverlay, InfoMain, InfoMainOverlay, InfoOnAlt, InfoOnMain, MiscLink, MiscScrim, NeutralAlt, NeutralMain, NeutralOnAlt, NeutralOnMain, PrimaryAlt, PrimaryAltOverlay, PrimaryMain, PrimaryMainOverlay, PrimaryOnAlt, PrimaryOnMain, SecondaryAlt, SecondaryAltOverlay, SecondaryMain, SecondaryMainOverlay, SecondaryOnAlt, SecondaryOnMain, SuccessAlt, SuccessAltOverlay, SuccessMain, SuccessMainOverlay, SuccessOnAlt, SuccessOnMain, SurfaceContrastHigh, SurfaceContrastLeast, SurfaceContrastLow, SurfaceContrastMid, SurfaceContrastMost, SurfaceMain, SurfaceOnSurface, SurfaceOnSurfaceAlt, SurfaceOutline, SurfaceOverlay, WarningAlt, WarningAltOverlay, WarningMain, WarningMainOverlay, WarningOnAlt, WarningOnMain };
